import React, { useState } from "react";
import { Card, Button, Text, Flex } from "rebass";
import { CardHeader } from "../../../../Components";
import { Patient } from "../../../../Types";
import { SettingsEditModal } from "./SettingsEditModal";
import { AddGameModal } from "./AddGameModal";

export const SettingsContainer: React.FC<{
  patient: Patient;
}> = ({ patient }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [addGameModalOpen, setAddGameModalOpen] = useState(false);
  const [gameSettingData, setGameSettingData] = useState<any>(null);

  return (
    <>
      <Card>
        <CardHeader
          headerText={"Games"}
          right={
            <Button
              onClick={() => {
                setAddGameModalOpen(true);
              }}
            >
              Add Game
            </Button>
          }
        />
        {(patient.games_settings || []).map((setting) => {
          return (
            <Card key={setting.Scene} padding={3}>
              <Flex justifyContent="space-between">
                <Text fontSize={3} fontWeight="bold">
                  {setting.Scene}
                </Text>
                <Button
                  onClick={() => {
                    setGameSettingData(setting);
                    setModalOpen(true);
                  }}
                >
                  Edit Settings
                </Button>
              </Flex>
            </Card>
          );
        })}
      </Card>
      {gameSettingData && (
        <SettingsEditModal
          data={gameSettingData}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      )}
      <AddGameModal isOpen={addGameModalOpen} setIsOpen={setAddGameModalOpen} />
    </>
  );
};
